// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-container {
  border-radius: 4px;
  margin: 0 auto;
  position: relative;
  width: 100%;
  height: 100%;
}
.editor-container .placeholder {
  position: absolute;
  top: 0px;
}
.editor-container p > a {
  text-decoration: underline !important;
  cursor: pointer;
  color: #216fdb;
}
.editor-container p > a > * {
  color: #216fdb !important;
}

.content-editable {
  width: 100%;
  height: 100%;
  outline: none;
  color: #333;
}
.content-editable ul,
.content-editable ol {
  padding-left: 2em;
  margin: 0.5em 0;
}

.editor-text-bold {
  font-weight: bold;
}

.editor-text-italic {
  font-style: italic;
}

.editor-text-underline {
  text-decoration: underline;
}

.editor-text-font-family {
  font-family: inherit !important;
  font-family: var(--font-family, inherit) !important;
}

.editor-text-font-size {
  font-size: inherit;
  font-size: var(--font-size, inherit);
}

.editor-text-color {
  color: inherit;
  color: var(--color, inherit);
}`, "",{"version":3,"sources":["webpack://./src/modules/dashboard/text-editor/text-editor.styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;AACJ;AAEE;EACE,qCAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;;AAKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AAFF;AAIE;;EAEE,iBAAA;EACA,eAAA;AAFJ;;AAMA;EACE,iBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,+BAAA;EAAA,mDAAA;AAHF;;AAMA;EACE,kBAAA;EAAA,oCAAA;AAHF;;AAMA;EACE,cAAA;EAAA,4BAAA;AAHF","sourcesContent":[".editor-container {\n  border-radius: 4px;\n  margin: 0 auto;\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  .placeholder {\n    position: absolute;\n    top: 0px;\n  }\n\n  p > a {\n    text-decoration: underline !important;\n    cursor: pointer;\n    color: #216fdb;\n\n    & > * {\n      color: #216fdb !important;\n    }\n  }\n}\n\n.content-editable {\n  width: 100%;\n  height: 100%;\n  outline: none;\n  color: #333;\n\n  ul,\n  ol {\n    padding-left: 2em;\n    margin: 0.5em 0;\n  }\n}\n\n.editor-text-bold {\n  font-weight: bold;\n}\n\n.editor-text-italic {\n  font-style: italic;\n}\n\n.editor-text-underline {\n  text-decoration: underline;\n}\n\n.editor-text-font-family {\n  font-family: var(--font-family, inherit) !important;\n}\n\n.editor-text-font-size {\n  font-size: var(--font-size, inherit);\n}\n\n.editor-text-color {\n  color: var(--color, inherit);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
